import * as getList from './reducers/get-list';
import * as update from './reducers/update';
import * as create from './reducers/create';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    GRADES_GET_LIST_REQUEST: getList.request,
    GRADES_GET_LIST_ERROR: getList.error,
    GRADES_GET_LIST_FINISH: getList.finish,

    GRADES_CREATE_REQUEST: create.request,
    GRADES_CREATE_ERROR: create.error,
    GRADES_CREATE_FINISH: create.finish,

    GRADES_UPDATE_REQUEST: update.request,
    GRADES_UPDATE_ERROR: update.error,
    GRADES_UPDATE_FINISH: update.finish,

    GRADES_DATA: update.bulk,
});
